import type { FunctionComponent } from 'react';
import ILLUSTRATIONS from 'constants/illustrations';
import { withTranslation, TranslateInterface } from 'utils/translation';
import { pages } from 'services/routing';
import { ValidateEmailPanel } from './ValidateEmailPanel';

const ExpiredPanel = ({ t }: TranslateInterface) => {
  return (
    <ValidateEmailPanel
      title={t('validateEmail.expired.title')}
      description={t('validateEmail.expired.description')}
      img={ILLUSTRATIONS.LOGO_WARNING_STARS}
      url={pages.MY_PROFILE}
      buttonTxt={t('validateEmail.goToProfile')}
    />
  );
};

export default withTranslation('userProfile')(ExpiredPanel) as FunctionComponent;
